module.exports = __webpack_public_path__ + "static/media/онлайн-конференция.c29747f4.jpg";